export default "__VITE_ASSET__C76hAmok__"